import { PickerHeading } from './PickerHeading';

export default PickerHeading;
